const $bookPageReaderText = $('.book-page__reader-text');

if ($bookPageReaderText.length) {
    const regexp = /<([a]+) *[^/]*?><\/a>/g;
    const arrBookPageReaderText = $bookPageReaderText.html().split(regexp);
    const arrBookPageReaderTextNew = [];
    let htmlPaginationBtn = '';
    const sPagenavBtnActive = 'pagenav__btn_active';
    const sBookPageReaderTextItemActive = 'book-page__reader-text-item_active';
    const cBookPageReaderTextBtn = '.book-page__reader-text-btn';
    let firstElArrIfUnder = '';

    $bookPageReaderText.html('');

    // Разделили текст регуляркой по тегу <a> и перебираем его массив
    arrBookPageReaderText.forEach((item) => {
        if (item !== 'a') {
            if (item.length < 300) { // Если между <a> слишком мало текста, добавляем в этот элемент массива следующий отрезок текста
                const last = arrBookPageReaderTextNew[arrBookPageReaderTextNew.length - 1]; // Сохраняем содержимое последнего элемента

                if (last) {
                    arrBookPageReaderTextNew?.pop();
                    arrBookPageReaderTextNew.push(last + item);
                } else {
                    firstElArrIfUnder += item;
                }
            } else {
                arrBookPageReaderTextNew.push(firstElArrIfUnder ? firstElArrIfUnder + item : item);
            }
        }
    });

    // Добавление пагинации в dom
    arrBookPageReaderTextNew.forEach((item, i) => {
        if (item.length > 0) {
            $bookPageReaderText.append(`<div class="book-page__reader-text-item${i === 0 ? ' book-page__reader-text-item_active' : ''}">${item}</div>`);
            htmlPaginationBtn += `<div class="book-page__reader-text-btn pagenav__btn pagenav__btn_num btn btn_border btn_bg-none${i === 0 ? ' pagenav__btn_active' : ''}">${i + 1}</div>`;
        }
    });

    $bookPageReaderText.append(`
    <div class="pagenav">
        <div class="pagenav__list">${htmlPaginationBtn}</div>
    </div>
    <div class="r40"></div>
`);

    // Обработка событий в пагинации
    $('body').on('click', cBookPageReaderTextBtn, function () {
        const $th = $(this);
        const index = $th.index() + 1;

        $(cBookPageReaderTextBtn).removeClass(sPagenavBtnActive);
        $th.addClass(sPagenavBtnActive);
        $('.book-page__reader-text-item').removeClass(sBookPageReaderTextItemActive);
        $(`.book-page__reader-text-item:nth-child(${index})`).addClass(sBookPageReaderTextItemActive);
    });
}